export const getSanitisedUrl = (url: string | null) => {
  if (url === null) return 'No URL';
  try {
    return new URL(url).hostname;
  } catch (e) {
    // noop
  }
  return 'No URL';
};
